import React from 'react';
import PropTypes from 'prop-types';
import ProductCarousel from './product-carousel';
import useSuggestedProducts from './use-suggested-products';

const SuggestedProducts = ({ productId, title }) => {
  const items = useSuggestedProducts(productId);

  if (items.length === 0) return null;

  return (
    <ProductCarousel
      key={productId}
      id={`suggested-products-carousel-${productId}`}
      className="suggested-products-list"
      title={title}
      items={items}
    />
  );
};

SuggestedProducts.propTypes = {
  productId: PropTypes.number,
  title: PropTypes.string,
};

SuggestedProducts.defaultProps = {
  title: 'Customers also bought',
};

export default SuggestedProducts;
